import {Directive, ElementRef, HostListener, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {AppConfigService, FormatterService} from '@ox/utils';

@Directive({
  selector: '[oxFormatter]'
})
export class FormatterDirective implements OnInit {
  private element!: HTMLElement;
  public ctrlVar: FormControl | undefined = undefined;
  public formfieldAttributes = this.appConfig.fieldAttributes;

  //Pass in html in a tag as [ctrl] and take the FormControl from the component.
  @Input() ctrl!: FormGroup; //FormControl;
  @Input() formCtrlNameInput: string | undefined = undefined;
  //Pass in html in a tag as formatter='insert format here'
  @Input('oxFormatter') format = '';

  constructor(
    private appConfig: AppConfigService,
    private ocFormatterService: FormatterService,
    private elRef: ElementRef
  ) {
  }

  ngOnInit() {
    this.element = this.elRef.nativeElement;
    this.ctrlVar = this.formCtrlNameInput ? this.ctrl.get(this.formCtrlNameInput) as FormControl: new FormControl();
  }

  @HostListener('change', ['$event'])
  onChange(event: KeyboardEvent) {
      if (this.format === 'money') {
        this.formatMoney(event);
      } else if (this.format === 'onstarAccountNumber') {
        this.formatOnStarAccountNumber(event);
      } else if (this.format === 'postalCode') {
        this.formatPostalCode(event);
      }
  }

  @HostListener('blur', ['$event'])
  onBlur(event: Event) {
      if (this.format === 'postalCode') {
        this.formatPostalCode(event);
      } else if (this.format === 'phone' || this.format === 'phoneCharacters') {
        this.formatPhone(event);
      } else if (this.format === 'taxId') {
        this.formatTaxId(event);
      } else if (this.format === 'CDI') {
        this.formatCDI(event);
      } else if (this.format === 'CNPJ') {
        this.formatCNPJ(event);
      }
  }

  public formatMoney = (evt: Event) => {
    const inputValue = (<HTMLInputElement> evt?.target).value;
    // check if inputValue is valid before continuing
    if (!inputValue) {
      return inputValue;
    }
    // format the value to two decimal places
    const formattedCurrency = (Number(inputValue) / 1)
      .toFixed(2);
    // update the view with the new value
    if (formattedCurrency !== inputValue) {
      this.ctrlVar ? this.ctrlVar.setValue(formattedCurrency): null;
    }
    return formattedCurrency;
  };

  public formatPhone = (evt: Event) => {
    return this.ctrlVar ? this.ocFormatterService.formatPhone(this.ctrlVar, (<HTMLInputElement>evt.target).value): null;
  };


  public formatTaxId = (evt: Event) => {
    // There is no taxId "mask" in OC-UI only pattern which doesn't useful here
    // const mask = this.formfieldAttributes.taxId.mask;
    return this.ctrlVar ? this.ocFormatterService.formatPhone(this.ctrlVar, (<HTMLInputElement>evt.target).value, undefined): null;
  };

  public formatCDI = (evt: Event) => {
    const mask = [/(\d{2})(\d{3})(\d{3})(\w{1})/, '$1.$2.$3-$4'];
    return this.ctrlVar ? this.ocFormatterService.formatCDI(this.ctrlVar, (<HTMLInputElement>evt.target).value, mask): null;
  };

  public formatCNPJ = (evt: Event) => {
    const mask = [/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'];
    return this.ctrlVar ? this.ocFormatterService.formatCNPJ(this.ctrlVar, (<HTMLInputElement>evt.target).value, mask): null;
  };

  public formatOnStarAccountNumber(evt: KeyboardEvent) {
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode === 45) {
      return;
    }
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault();
    }
  }

  //formats entered postal codes
  public formatPostalCode = (evt: Event) => {
    let inputValue = (<HTMLInputElement> evt.target).value;
    let formatPostalCode;
    const mask = this.formfieldAttributes.address.postalCode.mask;
    // check for valid input.
    if (!inputValue) {
      return inputValue;
    }
    if (inputValue != null && mask != null) {
      inputValue = inputValue.replace(/\s-\./g, '');
      formatPostalCode = inputValue.replace(mask[0], mask[1] as string);
      inputValue = formatPostalCode.toUpperCase();
      this.ctrlVar?.setValue(inputValue);
    }
    return inputValue;
  };

}
